export default "__VITE_ASSET__CxfStY2g__"